<template>
    <div :class="['range-slider', {'is-active': isChange}, modify]">
        <div class="range-slider__container">
            <div class="range-slider__range">
                <span class="range-slider__desc">{{ slider.label }}&nbsp;от&nbsp;</span>
                <span class="range-slider__value">{{ convertToDigit(lowerRange) }}</span>
            </div>
            <div class="range-slider__range">
                <span class="range-slider__desc">до&nbsp;</span>
                <span class="range-slider__value">{{ convertToDigit(upperRange) }}&nbsp;<span>{{ slider.postfix }}</span></span>
            </div>
        </div>

        <VueSlider
            v-model="slider.value"
            :min="slider.min"
            :max="slider.max"
            :enable-cross="true"
            :interval="setStepRange(slider.min, slider.max, sliderType)"
            @drag-end="changeFilters"
            @change="change" />

        <input v-if="isChangeDone"
               type="hidden"
               :data-counter="true"
               :data-min="slider.min"
               :data-min-value="lowerRange * (slider.multiply || 1)"
               :data-max="slider.max"
               :data-max-value="upperRange * (slider.multiply || 1)">

        <input v-if="isChangeDone"
               type="hidden"
               :name="`${sliderType}[min]`"
               :value="lowerRange * (slider.multiply || 1)">
        <input v-if="isChangeDone"
               type="hidden"
               :name="`${sliderType}[max]`"
               :value="upperRange * (slider.multiply || 1)">
    </div>
</template>

<script>
import 'vue-slider-component/theme/default.css';
import Utils from '@/helpers/Utils';
import VueSlider from 'vue-slider-component';

/**
 * Компонент для инпутов-слайдеров
 */
export default {
    name: 'RangeSlider',

    components: {
        VueSlider
    },

    props: {
        slider    : Object, // данные слайдера
        sliderType: String, // название слайдера
        modify    : String  // модификатор для слайдера
    },

    data() {
        return {
            isChange    : false, // изменяется ли сейчас слайдер
            isChangeDone: false  // завершилось ли изменение слайдера
        };
    },

    mounted() {
        // Если слайдер пришёл с уже изменёнными значениями (например из URL-параметров),
        // сразу включаем isChangeDone чтобы скрытые input-ы оказались в DOM и попали в FormData
        if (this.slider.value[0] > this.slider.min || this.slider.value[1] < this.slider.max) {
            this.isChangeDone = true;
        }
    },

    computed: {
        /**
         * Нижняя граница слайдера
         * @return {Number}
         */
        lowerRange() {
            return this.slider.value[0];
        },

        /**
         * Верхняя граница слайдера
         * @return {Number}
         */
        upperRange() {
            return this.slider.value[1];
        }
    },

    methods: {
        /**
         * Устанавливает шаг для слайдера
         * @param {Number} min - минимальное значение слайдера
         * @param {Number} max - максимальное значение слайдера
         * @param {String} type - название слайдера
         * @return {number}
         */
        setStepRange(min, max, type) {
            if (!Number.isInteger(min) || !Number.isInteger(max)) {
                return 0.1;
            }

            return 1;
        },

        /**
         * Конвертирует значение в число
         * @param {String} value - значение слайдера
         * @return {string}
         */
        convertToDigit(value) {
            // Если нужно число сжать, то сжимаем его
            // Допустим цену нужно выводить не 20000000, а 20 млн
            if (this.slider.compress) {
                const compressPrice = value / Number(this.slider.compress);

                if (Number.isInteger(compressPrice)) {
                    return Number(compressPrice.toString().toLocaleString('ru-Ru'));
                }

                return Number(compressPrice.toFixed(1)).toLocaleString('ru-Ru');
            }

            return Utils.convertToDigit(value);
        },

        /**
         * Событие при изменении слайдера
         */
        change() {
            this.isChange = true;
        },

        /**
         * Событие при заверешении изменении слайдера
         */
        changeFilters() {
            this.isChangeDone = true;

            // если после изменения слайдера оба значения равны min и max, снимаем активность
            if (this.isChangeDone) {
                if (this.lowerRange === this.slider.min && this.upperRange === this.slider.max) {
                    this.isChange = false;
                }
            }

            this.$nextTick(() => {
                this.$emit('onChange', this.slider);
            });
        },

        /**
         * Событие при сбросе слайдера
         */
        reset() {
            this.isChange = false;
            this.isChangeDone = false;
        }
    }
};
</script>

<style lang="scss">
@import "RangeSlider";
</style>

